export enum CustomScriptType {
  UPDATE ="UPDATE",
  WORKFLOW ="WORKFLOW"
}
